import React from 'react';

import { NoneControlProps } from './NoneControl.interfaces';

const NoneControl = (props: NoneControlProps) => {
  return <div />;
};

export default NoneControl;
